<div class="forecast d-flex align-items-end justify-content-between" *ngIf="weather && weather.main">
  <span class="location">{{weather.name}}, {{weather.sys.country}}</span>
  <div class="d-flex flex-row">
    <i class="wi fa-2x" [ngClass]="getIconClass()"></i>
    <div class="d-flex align-items-baseline" style="margin-left: 5px;">
      <span class="temperature">{{weather.main.temp}}</span> <i class="wi fa-2x wi-celsius"></i>
    </div>
  </div>
</div>
